/**
 * Created by wangjianwen on 2017/10/16.
 */
import actions from './actions.js';
import mutations from './mutations.js';
import getters from './getters.js';


let state = {
    examRegId:null,
    examRegInfo: null,
    batchId:null,
    promiseState:"1",
    backOrNextStep:"back"
}

export default {
    state,
    actions,
    mutations,
    getters
}